import { COLOR_ACCENT, COLOR_BG, COLOR_STROKE, COLOR_WH, COLOR_BG_Black, COLOR_TEXT, COLOR_TEXT_Black } from './colors.constants';
import { colorsButton, colorsIconButton, colorsRadioAndCheckbox, colorsTextField } from './components';

export const colorThemes = {
    background: COLOR_BG,
    mainColor: COLOR_WH,
    textColor: COLOR_TEXT,
    borderMain: COLOR_STROKE,
    borderAccent: COLOR_ACCENT,
    ...colorsButton,
    ...colorsIconButton,
    ...colorsRadioAndCheckbox,
    ...colorsTextField,
};
export const colorThemesBlack = {
    background: COLOR_BG_Black,
    mainColor: COLOR_WH,
    textColor: COLOR_TEXT_Black,
    borderMain: COLOR_STROKE,
    borderAccent: COLOR_ACCENT,
    ...colorsButton,
    ...colorsIconButton,
    ...colorsRadioAndCheckbox,
    ...colorsTextField,
};
